import { MeetingSchedulerStatus } from "@fidget/common/models/meeting-scheduler-status";
import { Instance, types } from "mobx-state-tree";
import { AgentReferenceType } from "../../../agent";
import { ChatItemStatus } from "../ChatItemStatus";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

/**
 * Meeting Scheduler
 */
export const MeetingSchedulerChatItem = types
  .compose(
    "MeetingSchedulerChatItem",
    BaseChatItem,
    types.model({
      type: types.literal(ChatItemType.MeetingScheduler),
      user: AgentReferenceType,
      progressStatus: types.optional(
        types.enumeration<MeetingSchedulerStatus>(
          "MeetingSchedulerStatus",
          Object.values(MeetingSchedulerStatus)
        ),
        MeetingSchedulerStatus.PENDING
      ),
      token: types.string,
      meetingId: types.maybe(types.string),
      // FIXME: only because chat item group requires it
      status: types.optional(types.literal(ChatItemStatus.SENT), ChatItemStatus.SENT)
    })
  )
  .extend((self) => {
    const views = {
      get shown(): boolean {
        return self.progressStatus !== MeetingSchedulerStatus.SCHEDULED;
      }
    };
    const actions = {
      /**
       * Update MeetingSchedulerChatItem from room_message_updated event
       * @param {any} context update event payload
       */
      updateFromEvent(context: any) {
        Object.assign(self, {
          progressStatus: context.status,
          token: context.token
        });
      }
    };
    return { views, actions };
  });

export interface IMeetingSchedulerChatItem extends Instance<typeof MeetingSchedulerChatItem> {}
